// a browser that never answers must not hold back the log it feeds
const SIGNAL_TIMEOUT_MS = 1000;

// true or false only when the browser actually answered; anything else is unknown
const read = async (question) => {
    let timer;

    try {
        const value = await Promise.race([
            question(),
            new Promise((resolve) => {
                timer = setTimeout(() => resolve(null), SIGNAL_TIMEOUT_MS);
            }),
        ]);

        return typeof value === "boolean" ? value : null;
    } catch (error) {
        return null;
    } finally {
        clearTimeout(timer);
    }
};

// NotAllowedError hides why a ceremony failed, so these say whether the phone route could work here
const passkeyDeviceSignals = async () => {
    const [hybridTransport, bluetoothAvailable, platformAuthenticator] = await Promise.all([
        read(async () => (await window.PublicKeyCredential?.getClientCapabilities?.())?.hybridTransport),
        read(() => navigator.bluetooth?.getAvailability?.()),
        read(() => window.PublicKeyCredential?.isUserVerifyingPlatformAuthenticatorAvailable?.()),
    ]);

    return {hybridTransport, bluetoothAvailable, platformAuthenticator};
};

export default passkeyDeviceSignals;
